import { render, staticRenderFns } from "./ChartMemberAge.vue?vue&type=template&id=ff387396"
import script from "./ChartMemberAge.vue?vue&type=script&lang=js"
export * from "./ChartMemberAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports